import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../api/axiosInstance";

export const fetchActivityLogs = createAsyncThunk(
  "activityLogs/fetchAll",
  async (query = "", thunkAPI) => {
    try {
      const res = await api.get(`/dashboard/activity-logs${query}`);
      return res.data.data.activity_logs;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getActivityLog = createAsyncThunk(
  "activityLogs/getOne",
  async (id, thunkAPI) => {
    try {
      const res = await api.get(`/dashboard/activity-logs/${id}`);
      return res.data.data.activity_log;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

const activityLogsSlicer = createSlice({
  name: "activityLogs",
  initialState: {
    data: null,
    currentLog: null,
    loading: {
      fetch: false,
      get: false,
    },
    error: null,
  },
  reducers: {
    clearActivityLog(state) {
      state.currentLog = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchActivityLogs.pending, (state) => {
        state.loading.fetch = true;
      })
      .addCase(fetchActivityLogs.fulfilled, (state, action) => {
        state.loading.fetch = false;
        state.data = action.payload;
      })
      .addCase(fetchActivityLogs.rejected, (state) => {
        state.loading.fetch = false;
        state.error = true;
      })
      .addCase(getActivityLog.pending, (state) => {
        state.loading.get = true;
      })
      .addCase(getActivityLog.fulfilled, (state, action) => {
        state.loading.get = false;
        state.currentLog = action.payload;
      })
      .addCase(getActivityLog.rejected, (state) => {
        state.loading.get = false;
        state.error = true;
      });
  },
});

export const { clearActivityLog } = activityLogsSlicer.actions;
export default activityLogsSlicer.reducer;
